export const formatCellText = (value) => {
  if (value === null || value === undefined) return "-";
  const text = String(value).trim();
  return text.length ? text : "-";
};

export const getTrendDirection = (trend) => {
  // Accepts: "up"/"down", 1/-1, "1"/"-1", "increased"/"decreased"
  if (trend === null || trend === undefined || trend === "") return null;

  const normalized =
    typeof trend === "string" ? trend.trim().toLowerCase() : trend;

  const UP = new Set(["up", "increased", 1, "1"]);
  const DOWN = new Set(["down", "decreased", -1, "-1"]);

  if (UP.has(normalized)) return "up";
  if (DOWN.has(normalized)) return "down";
  return null;
};

export const toneForTrend = (trend) => {
  const dir = getTrendDirection(trend);
  if (dir === "up") return "du-odds-up";
  if (dir === "down") return "du-odds-down";
  return "text-[var(--theme-text)]";
};

